import * as moment from "moment-timezone";
import { ELanguage } from "src/interfaces";
import jaLocale from "date-fns/locale/ja";
import enLocale from "date-fns/locale/en-US";
import { registerLocale } from "react-datepicker";
import momentlc from "moment";

export const convertUtcToJapanDate = (
  datetime: string | number,
  format = "MM月DD日"
) => {
  const language = localStorage.getItem("lang");
  if (format === "MM月DD日") {
    format = language === ELanguage.EN ? "MM-DD" : "MM月DD日";
  }
  if (typeof datetime !== "string" && typeof datetime !== "number") return "";
  return moment
    .tz(moment.unix(Math.floor(Number(datetime))), "Asia/Tokyo")
    .format(format);
};

export const convertUtcToJapanMomentDate = (
  datetime: string | number
): moment.Moment => {
  return moment.tz(moment.unix(Math.floor(Number(datetime))), "Asia/Tokyo");
};

export const registerDatepickerLocale = () => {
  const language = localStorage.getItem("lang");
  if (language === ELanguage.JA) {
    registerLocale("ja", jaLocale);
    momentlc.locale("ja");
  } else {
    registerLocale("en", enLocale);
    momentlc.locale("en");
  }
};

export const getYearMonthString = (date: Date) => {
  const language = localStorage.getItem("lang");
  if (language === ELanguage.JA) {
    return `${date.getFullYear()}年 ${date.getMonth() + 1}月`;
  } else {
    const month =
      date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
    return `${month}-${date.getFullYear()}`;
  }
};

export const getMonthDateString = (date: Date, format: string) => {
  const language = localStorage.getItem("lang");
  if (language === ELanguage.JA) {
    return momentlc(date, format).format("M月D日");
  } else {
    return momentlc(date, format).format("DD-MM");
  }
};
